(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabincraft-finder-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const configSelector = '[data-ccfc-config]';

    const initialise = (config) => {
      if (config.dataset.ccfcReady === 'true') return;

      const finder = document.querySelector('[id^="ccpf-finder-"]');
      const results = finder ? finder.querySelector('.ccpf__results') : null;
      if (!finder || !results) return;
      config.dataset.ccfcReady = 'true';

      const existingOffer = results.querySelector('[data-ccfc-inline]');
      if (existingOffer) existingOffer.remove();

      const offer = document.createElement('div');
      offer.className = 'ccfc-inline';
      offer.dataset.ccfcInline = '';
      offer.hidden = true;
      offer.innerHTML = `
        <div class="ccfc-inline__copy">
          <strong class="ccfc-inline__title" data-ccfc-title></strong>
          <span class="ccfc-inline__note" data-ccfc-note></span>
        </div>
        <div class="ccfc-inline__price" aria-live="polite">
          <strong data-ccfc-price></strong>
          <span data-ccfc-saving></span>
        </div>
        <div class="ccfc-inline__actions">
          <span class="ccfc-inline__kit-links" data-ccfc-links></span>
          <button class="ccpf__button ccpf__button--light ccfc-inline__button" type="button" data-ccfc-add disabled></button>
        </div>
        <p class="ccfc-inline__message" data-ccfc-message role="status" aria-live="polite"></p>
      `;

      const steps = results.querySelector('.ccpf__steps-wrap');
      results.insertBefore(offer, steps || null);

      const builderId = `ccfc-builder-${config.dataset.sectionId || Math.random().toString(36).slice(2)}`;
      const builderPromo = document.createElement('button');
      builderPromo.className = 'ccfc-builder-promo';
      builderPromo.type = 'button';
      builderPromo.dataset.ccfcBuilderToggle = '';
      builderPromo.setAttribute('aria-controls', builderId);
      builderPromo.setAttribute('aria-expanded', 'false');
      builderPromo.innerHTML = `
        <span class="ccfc-builder-promo__copy">
          <span class="ccfc-builder-promo__eyebrow" data-ccfc-builder-promo-eyebrow></span>
          <strong class="ccfc-builder-promo__title" data-ccfc-builder-promo-title></strong>
          <span class="ccfc-builder-promo__note" data-ccfc-builder-promo-note></span>
        </span>
        <span class="ccfc-builder-promo__saving" aria-label="Custom kit discount">
          <strong data-ccfc-builder-promo-percent></strong>
          <span>off</span>
        </span>
        <span class="ccfc-builder-promo__action" data-ccfc-builder-promo-action></span>
      `;
      results.insertBefore(builderPromo, offer);

      const builder = document.createElement('section');
      builder.className = 'ccfc-builder';
      builder.id = builderId;
      builder.dataset.ccfcBuilder = '';
      builder.hidden = true;
      builder.setAttribute('aria-labelledby', `${builderId}-title`);
      builder.innerHTML = `
        <div class="ccfc-builder__header">
          <div>
            <span class="ccfc-builder__eyebrow" data-ccfc-builder-eyebrow></span>
            <h3 class="ccfc-builder__title" id="${builderId}-title"></h3>
            <span class="ccfc-builder__note" data-ccfc-builder-note></span>
          </div>
          <div class="ccfc-builder__header-actions">
            <span class="ccfc-builder__discount">
              <strong data-ccfc-builder-discount></strong>
              <span>on 2+ products</span>
            </span>
            <button class="ccpf__button ccpf__button--ghost" type="button" data-ccfc-builder-close></button>
          </div>
        </div>
        <div class="ccfc-builder__grid" data-ccfc-builder-grid aria-live="polite"></div>
        <div class="ccfc-builder__footer">
          <div>
            <strong class="ccfc-builder__count" data-ccfc-builder-count></strong>
            <span class="ccfc-builder__status" data-ccfc-builder-status></span>
          </div>
          <div class="ccfc-builder__total-wrap">
            <div class="ccfc-builder__price-row">
              <span data-ccfc-builder-original-label></span>
              <span class="ccfc-builder__original" data-ccfc-builder-original></span>
            </div>
            <div class="ccfc-builder__price-row">
              <span data-ccfc-builder-saving-label></span>
              <strong class="ccfc-builder__saving" data-ccfc-builder-saving></strong>
            </div>
            <div class="ccfc-builder__price-row ccfc-builder__price-row--total">
              <span data-ccfc-builder-total-label></span>
              <strong class="ccfc-builder__total" data-ccfc-builder-total></strong>
            </div>
          </div>
          <button class="ccpf__button ccfc-builder__add" type="button" data-ccfc-builder-add disabled></button>
        </div>
        <p class="ccfc-builder__message" data-ccfc-builder-message role="status" aria-live="polite"></p>
      `;
      results.insertBefore(builder, offer);

      let routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      if (!routeRoot.endsWith('/')) routeRoot += '/';

      const productHandles = {
        opaline: 'opaline-car-shampoo',
        mitt: 'premium-washing-mitt',
        aquagrip: 'aquagrip-1600',
        cora: 'h2craft',
        coralwave: 'coralwave-850',
        forgeflex: 'forgeflex-wheel-brushes',
        ceramiq: 'ceramiq',
        opal: 'opal-1200',
        cabinpure: 'cabinpure',
        leather: 'leatherlift-foam',
        quickroll: 'quickroll-50',
        crystal: 'crystalweave-glass-cloth',
        ultra: 'ultra-trim-and-tyre-revive',
        tyrex: 'tirex'
      };

      const group = (primary, fallback) => ({ primary, fallback });
      const individual = (...handles) => group('', handles);

      const fullQuickProducts = [
        productHandles.opaline,
        productHandles.cabinpure,
        productHandles.leather,
        productHandles.ultra,
        productHandles.ceramiq
      ];

      const fullCompleteProducts = [
        productHandles.opaline,
        productHandles.mitt,
        productHandles.aquagrip,
        productHandles.ceramiq,
        productHandles.opal,
        productHandles.cabinpure,
        productHandles.leather,
        productHandles.quickroll,
        productHandles.crystal,
        productHandles.ultra,
        productHandles.tyrex
      ];

      const routines = {
        'wash:quick': {
          groups: [group(config.dataset.kitWashQuick, [productHandles.opaline, productHandles.mitt, productHandles.aquagrip])]
        },
        'wash:complete': {
          groups: [group(config.dataset.kitWashComplete, [productHandles.forgeflex, productHandles.opaline, productHandles.mitt, productHandles.aquagrip])]
        },
        'protect:quick': {
          groups: [group(config.dataset.kitProtectQuick, [productHandles.ceramiq, productHandles.opal])]
        },
        'protect:complete': {
          groups: [group(config.dataset.kitProtectComplete, [productHandles.opaline, productHandles.mitt, productHandles.ceramiq, productHandles.opal])]
        },
        'interior:quick': {
          groups: [group(config.dataset.kitInteriorQuick, [productHandles.cabinpure, productHandles.leather, productHandles.quickroll, productHandles.crystal])]
        },
        'interior:complete': {
          groups: [group(config.dataset.kitInteriorComplete, [productHandles.cabinpure, productHandles.leather, productHandles.quickroll, productHandles.crystal])]
        },
        'trim:quick': {
          groups: [group(config.dataset.kitTrimQuick, [productHandles.ultra, productHandles.tyrex])]
        },
        'trim:complete': {
          groups: [group(config.dataset.kitTrimComplete, [productHandles.forgeflex, productHandles.opaline, productHandles.ultra, productHandles.tyrex])]
        },
        'full:quick': {
          groups: [group(config.dataset.kitFullQuick, fullQuickProducts)]
        },
        'full:complete': {
          groups: config.dataset.kitFullComplete
            ? [group(config.dataset.kitFullComplete, fullCompleteProducts)]
            : [
                group(config.dataset.kitProtectComplete, [productHandles.opaline, productHandles.mitt, productHandles.ceramiq, productHandles.opal]),
                group(config.dataset.kitInteriorComplete, [productHandles.cabinpure, productHandles.leather, productHandles.quickroll, productHandles.crystal]),
                group(config.dataset.kitTrimQuick, [productHandles.ultra, productHandles.tyrex]),
                individual(productHandles.aquagrip)
              ]
        }
      };

      const palettes = {
        wash: { accent: '#f47a2c', rgb: '244, 122, 44', fill: '#f47a2c' },
        protect: { accent: '#13bfd1', rgb: '19, 191, 209', fill: '#13bfd1' },
        interior: { accent: '#35a96b', rgb: '53, 169, 107', fill: '#35a96b' },
        trim: { accent: '#8d63d2', rgb: '141, 99, 210', fill: '#8d63d2' },
        full: {
          accent: '#ebe8df',
          rgb: '235, 232, 223',
          fill: 'linear-gradient(90deg, #f47a2c 0 25%, #13bfd1 25% 50%, #35a96b 50% 75%, #8d63d2 75%)'
        }
      };

      const applyPalette = (goal) => {
        const palette = palettes[goal] || palettes.protect;
        finder.dataset.ccfcGoal = goal;
        finder.style.setProperty('--ccfc-accent', palette.accent);
        finder.style.setProperty('--ccfc-accent-rgb', palette.rgb);
        finder.style.setProperty('--ccfc-accent-fill', palette.fill);
        offer.style.setProperty('--ccfc-accent', palette.accent);
        offer.style.setProperty('--ccfc-accent-rgb', palette.rgb);
        offer.style.setProperty('--ccfc-accent-fill', palette.fill);
      };

      const titleElement = offer.querySelector('[data-ccfc-title]');
      const noteElement = offer.querySelector('[data-ccfc-note]');
      const priceElement = offer.querySelector('[data-ccfc-price]');
      const savingElement = offer.querySelector('[data-ccfc-saving]');
      const linkContainer = offer.querySelector('[data-ccfc-links]');
      const buttonElement = offer.querySelector('[data-ccfc-add]');
      const messageElement = offer.querySelector('[data-ccfc-message]');
      const builderToggle = builderPromo;
      const builderPromoEyebrow = builderPromo.querySelector('[data-ccfc-builder-promo-eyebrow]');
      const builderPromoTitle = builderPromo.querySelector('[data-ccfc-builder-promo-title]');
      const builderPromoNote = builderPromo.querySelector('[data-ccfc-builder-promo-note]');
      const builderPromoPercent = builderPromo.querySelector('[data-ccfc-builder-promo-percent]');
      const builderPromoAction = builderPromo.querySelector('[data-ccfc-builder-promo-action]');
      const builderClose = builder.querySelector('[data-ccfc-builder-close]');
      const builderGrid = builder.querySelector('[data-ccfc-builder-grid]');
      const builderEyebrow = builder.querySelector('[data-ccfc-builder-eyebrow]');
      const builderTitle = builder.querySelector('.ccfc-builder__title');
      const builderNote = builder.querySelector('[data-ccfc-builder-note]');
      const builderDiscount = builder.querySelector('[data-ccfc-builder-discount]');
      const builderCount = builder.querySelector('[data-ccfc-builder-count]');
      const builderStatus = builder.querySelector('[data-ccfc-builder-status]');
      const builderOriginalLabel = builder.querySelector('[data-ccfc-builder-original-label]');
      const builderOriginal = builder.querySelector('[data-ccfc-builder-original]');
      const builderSavingLabel = builder.querySelector('[data-ccfc-builder-saving-label]');
      const builderSaving = builder.querySelector('[data-ccfc-builder-saving]');
      const builderTotalLabel = builder.querySelector('[data-ccfc-builder-total-label]');
      const builderTotal = builder.querySelector('[data-ccfc-builder-total]');
      const builderAdd = builder.querySelector('[data-ccfc-builder-add]');
      const builderMessage = builder.querySelector('[data-ccfc-builder-message]');
      const productCache = new Map();
      const builderItems = new Map();
      const selectedBuilderIds = new Set();
      let requestNumber = 0;
      let currentOffer = null;
      let updateFrame = 0;
      let builderRequest = null;

      const configuredDiscountPercent = Number(config.dataset.builderDiscountPercent);
      const builderDiscountPercent = Number.isFinite(configuredDiscountPercent)
        ? Math.min(100, Math.max(0, configuredDiscountPercent))
        : 10;
      const builderDiscountCopy = `${builderDiscountPercent}%`;

      builderPromoEyebrow.textContent = config.dataset.builderPromoEyebrow;
      builderPromoTitle.textContent = config.dataset.builderTitle;
      builderPromoNote.textContent = config.dataset.builderPromoNote;
      builderPromoPercent.textContent = builderDiscountCopy;
      builderPromoAction.textContent = config.dataset.builderButton;
      builderClose.textContent = config.dataset.builderClose;
      builderEyebrow.textContent = config.dataset.builderPromoEyebrow;
      builderTitle.textContent = config.dataset.builderTitle;
      builderNote.textContent = config.dataset.builderNote;
      builderDiscount.textContent = `${builderDiscountCopy} off`;
      builderOriginalLabel.textContent = config.dataset.builderOriginalTotal;
      builderSavingLabel.textContent = `${config.dataset.builderSaving} (${builderDiscountCopy})`;
      builderTotalLabel.textContent = config.dataset.builderTotal;
      builderAdd.textContent = config.dataset.builderAdd;

      const money = new Intl.NumberFormat(config.dataset.locale || 'en-AU', {
        style: 'currency',
        currency: config.dataset.currency || 'AUD'
      });

      const formatMoney = (cents) => money.format(cents / 100);

      const loadProduct = (handle) => {
        if (!handle) return Promise.resolve(null);
        if (productCache.has(handle)) return productCache.get(handle);

        // Prices, compare-at prices, availability and variant IDs always come from
        // the current Shopify storefront response. Nothing here is price-configured.
        const productRequest = fetch(`${routeRoot}products/${encodeURIComponent(handle)}.js`, {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then((response) => {
            if (!response.ok) return null;
            return response.json();
          })
          .then((product) => {
            if (!product || !Array.isArray(product.variants)) return null;
            const variant = product.variants.find((candidate) => candidate.available) || product.variants[0];
            if (!variant) return null;

            const price = Number(variant.price);
            if (!Number.isFinite(price) || price < 0) return null;
            const rawCompareAt = Number(variant.compare_at_price);
            const compareAt = Number.isFinite(rawCompareAt) && rawCompareAt > price
              ? rawCompareAt
              : price;
            const featuredImage = typeof product.featured_image === 'string'
              ? product.featured_image
              : product.featured_image && product.featured_image.src;
            const firstImage = Array.isArray(product.images) ? product.images[0] : '';
            const image = featuredImage || (typeof firstImage === 'string' ? firstImage : firstImage && firstImage.src) || '';
            const tags = Array.isArray(product.tags)
              ? product.tags
              : typeof product.tags === 'string' ? product.tags.split(',') : [];

            return {
              available: Boolean(variant.available),
              compareAt,
              handle,
              id: variant.id,
              image,
              price,
              tags,
              title: product.title,
              type: product.type || '',
              url: product.url || `${routeRoot}products/${handle}`
            };
          })
          .catch(() => null);

        productCache.set(handle, productRequest);
        return productRequest;
      };

      const resolveGroup = async (routineGroup) => {
        const [primaryProduct, fallbackProducts] = await Promise.all([
          routineGroup.primary ? loadProduct(routineGroup.primary) : Promise.resolve(null),
          Promise.all(routineGroup.fallback.map(loadProduct))
        ]);
        const fallbackItems = fallbackProducts.filter(Boolean);
        const fallbackComplete = fallbackItems.length === routineGroup.fallback.length;
        const fallbackTotal = fallbackItems.reduce((sum, item) => sum + item.price, 0);

        if (primaryProduct && primaryProduct.available) {
          return {
            complete: true,
            items: [primaryProduct],
            listTotal: fallbackComplete
              ? Math.max(primaryProduct.price, fallbackTotal)
              : Math.max(primaryProduct.price, primaryProduct.compareAt),
            usedFallback: false,
            usedPrimary: true
          };
        }

        return {
          complete: fallbackComplete,
          items: fallbackItems,
          listTotal: fallbackItems.reduce((sum, item) => sum + item.compareAt, 0),
          usedFallback: Boolean(routineGroup.primary),
          usedPrimary: false
        };
      };

      const cleanProductTitle = (title) => title
        .replace(/\s+Sale$/i, '')
        .replace(/^The\s+/, 'the ');

      const classifyProduct = (item) => {
        const text = `${item.title} ${item.type} ${item.tags.join(' ')}`.toLowerCase();
        if (/ceramiq|opal 1200|protection|ceramic/.test(text)) return { accent: '#13bfd1', label: 'Protection' };
        if (/cabinpure|leather|quickroll|crystal|glass|interior/.test(text)) return { accent: '#35a96b', label: 'Interior' };
        if (/ultra|tyrex|tirex|tyre|trim|wheel|forgeflex/.test(text)) return { accent: '#8d63d2', label: 'Trim & tyres' };
        return { accent: '#f47a2c', label: 'Wash & exterior' };
      };

      const getSelectedBuilderItems = () => Array.from(selectedBuilderIds)
        .map((id) => builderItems.get(id))
        .filter(Boolean);

      const updateBuilderSummary = () => {
        const selected = getSelectedBuilderItems();
        const count = selected.length;
        const originalTotal = selected.reduce((sum, item) => sum + item.price, 0);
        const discountEligible = count >= 2;
        const saving = discountEligible
          ? selected.reduce((sum, item) => sum + Math.round(item.price * builderDiscountPercent / 100), 0)
          : 0;
        const discountedTotal = Math.max(0, originalTotal - saving);
        builderCount.textContent = `${count} ${count === 1 ? 'product' : 'products'} selected`;
        builderStatus.textContent = discountEligible ? config.dataset.builderReady : config.dataset.builderMinimum;
        builderOriginal.textContent = formatMoney(originalTotal);
        builderOriginal.classList.toggle('is-discounted', discountEligible);
        builderSaving.textContent = discountEligible ? `−${formatMoney(saving)}` : formatMoney(0);
        builderTotal.textContent = formatMoney(discountedTotal);
        builderAdd.disabled = !discountEligible || selected.some((item) => !item.available);
        builderMessage.textContent = '';
      };

      const renderBuilderItems = (items) => {
        builderItems.clear();
        if (!items.length) {
          const empty = document.createElement('p');
          empty.className = 'ccfc-builder__loading';
          empty.textContent = config.dataset.unavailableLabel;
          builderGrid.replaceChildren(empty);
          builderGrid.removeAttribute('aria-busy');
          updateBuilderSummary();
          return;
        }
        builderGrid.replaceChildren(...items.map((item) => {
          const category = classifyProduct(item);
          const itemId = String(item.id);
          builderItems.set(itemId, item);

          const button = document.createElement('button');
          button.className = 'ccfc-builder__item';
          button.type = 'button';
          button.dataset.ccfcBuilderProduct = itemId;
          button.setAttribute('aria-pressed', String(selectedBuilderIds.has(itemId)));
          button.style.setProperty('--ccfc-item-accent', category.accent);
          button.disabled = !item.available;

          const imageWrap = document.createElement('span');
          imageWrap.className = 'ccfc-builder__image';
          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = '';
            image.loading = 'lazy';
            imageWrap.append(image);
          }

          const copy = document.createElement('span');
          copy.className = 'ccfc-builder__item-copy';
          const title = document.createElement('strong');
          title.className = 'ccfc-builder__item-title';
          title.textContent = cleanProductTitle(item.title);
          const meta = document.createElement('span');
          meta.className = 'ccfc-builder__item-meta';
          meta.textContent = item.available
            ? `${category.label} · ${formatMoney(item.price)}`
            : config.dataset.builderSoldOut;
          copy.append(title, meta);

          const select = document.createElement('span');
          select.className = 'ccfc-builder__select';
          select.setAttribute('aria-hidden', 'true');
          select.textContent = selectedBuilderIds.has(itemId) ? '✓' : '+';

          button.append(imageWrap, copy, select);
          return button;
        }));
        builderGrid.removeAttribute('aria-busy');
        updateBuilderSummary();
      };

      const loadBuilder = () => {
        if (builderRequest) return builderRequest;
        const configuredHandles = (config.dataset.builderHandles || '')
          .split(',')
          .map((handle) => handle.trim())
          .filter(Boolean);
        const requiredBuilderHandles = [productHandles.cora, productHandles.coralwave];
        const handles = Array.from(new Set(
          configuredHandles.length
            ? [...requiredBuilderHandles, ...configuredHandles]
            : Object.values(productHandles)
        )).slice(0, 24);
        const loading = document.createElement('p');
        loading.className = 'ccfc-builder__loading';
        loading.textContent = config.dataset.builderLoading;
        builderGrid.replaceChildren(loading);
        builderGrid.setAttribute('aria-busy', 'true');
        builderRequest = Promise.all(handles.map(loadProduct))
          .then((items) => renderBuilderItems(items.filter(Boolean)));
        return builderRequest;
      };

      const setBuilderOpen = (isOpen) => {
        builder.hidden = !isOpen;
        builderToggle.setAttribute('aria-expanded', String(isOpen));
        builderToggle.classList.toggle('is-open', isOpen);
        builderPromoAction.textContent = isOpen ? config.dataset.builderClose : config.dataset.builderButton;
        if (isOpen) loadBuilder();
      };

      const update = async () => {
        const goalButton = finder.querySelector('[data-ccpf-goal][aria-pressed="true"]');
        const modeButton = finder.querySelector('[data-ccpf-mode][aria-pressed="true"]');
        if (!goalButton || !modeButton) {
          offer.hidden = true;
          return;
        }

        const goal = goalButton.dataset.ccpfGoal;
        const mode = modeButton.dataset.ccpfMode;
        const routine = routines[`${goal}:${mode}`];
        if (!routine) {
          offer.hidden = true;
          return;
        }

        applyPalette(goal);

        const activeRequest = ++requestNumber;
        currentOffer = null;
        offer.hidden = false;
        offer.setAttribute('aria-busy', 'true');
        titleElement.textContent = config.dataset.loadingLabel;
        noteElement.textContent = '';
        priceElement.textContent = '';
        savingElement.textContent = '';
        linkContainer.replaceChildren();
        messageElement.textContent = '';
        buttonElement.disabled = true;
        buttonElement.textContent = mode === 'complete' ? config.dataset.completeButton : config.dataset.quickButton;

        const resolvedGroups = await Promise.all(routine.groups.map(resolveGroup));
        if (activeRequest !== requestNumber) return;

        const items = resolvedGroups.flatMap((resolvedGroup) => resolvedGroup.items);
        const kitItems = resolvedGroups
          .filter((resolvedGroup) => resolvedGroup.usedPrimary)
          .flatMap((resolvedGroup) => resolvedGroup.items);
        const usedFallback = resolvedGroups.some((resolvedGroup) => resolvedGroup.usedFallback);
        const usedPrimaryCount = resolvedGroups.filter((resolvedGroup) => resolvedGroup.usedPrimary).length;
        const singleKit = items.length === 1 && usedPrimaryCount === 1 && routine.groups.length === 1;
        const allAvailable = items.length > 0 && items.every((item) => item.available);
        const completeResolution = resolvedGroups.every((resolvedGroup) => resolvedGroup.complete);
        const total = items.reduce((sum, item) => sum + item.price, 0);
        const listTotal = resolvedGroups.reduce((sum, resolvedGroup) => sum + resolvedGroup.listTotal, 0);
        const saving = Math.max(0, listTotal - total);
        const goalLabel = (goalButton.querySelector('b') || goalButton).textContent.trim();

        titleElement.textContent = singleKit
          ? `${config.dataset.getLabel} ${cleanProductTitle(items[0].title)}`
          : `${config.dataset.getLabel} your ${mode === 'complete' ? 'complete' : 'quick'} ${goalLabel} routine`;

        if (usedFallback) {
          noteElement.textContent = config.dataset.individualLabel;
        } else if (singleKit) {
          noteElement.textContent = config.dataset.kitMatchLabel;
        } else if (usedPrimaryCount > 0) {
          noteElement.textContent = config.dataset.matchedKitsLabel;
        } else {
          noteElement.textContent = config.dataset.individualLabel;
        }

        priceElement.textContent = formatMoney(total);
        savingElement.textContent = saving > 0
          ? `${config.dataset.saveLabel} ${formatMoney(saving)}`
          : config.dataset.totalLabel;

        kitItems.forEach((item) => {
          const link = document.createElement('a');
          link.className = 'ccpf__button ccpf__button--ghost';
          link.href = item.url;
          link.textContent = kitItems.length === 1
            ? config.dataset.viewKitLabel
            : `View ${cleanProductTitle(item.title)}`;
          linkContainer.append(link);
        });

        offer.setAttribute('aria-busy', 'false');
        buttonElement.disabled = !allAvailable || !completeResolution;

        if (!allAvailable || !completeResolution) {
          messageElement.textContent = config.dataset.unavailableLabel;
          return;
        }

        currentOffer = { goal, mode, items };
      };

      const scheduleUpdate = () => {
        if (updateFrame) window.cancelAnimationFrame(updateFrame);
        updateFrame = window.requestAnimationFrame(() => {
          updateFrame = 0;
          update();
        });
      };

      const onFinderClick = (event) => {
        if (!event.target.closest('[data-ccpf-goal], [data-ccpf-mode]')) return;
        scheduleUpdate();
      };

      const onBuilderToggle = () => setBuilderOpen(builder.hidden);
      const onBuilderClose = () => setBuilderOpen(false);

      const onBuilderSelect = (event) => {
        const button = event.target.closest('[data-ccfc-builder-product]');
        if (!button || button.disabled) return;
        const itemId = button.dataset.ccfcBuilderProduct;
        if (selectedBuilderIds.has(itemId)) {
          selectedBuilderIds.delete(itemId);
        } else {
          selectedBuilderIds.add(itemId);
        }
        const isSelected = selectedBuilderIds.has(itemId);
        button.setAttribute('aria-pressed', String(isSelected));
        const select = button.querySelector('.ccfc-builder__select');
        if (select) select.textContent = isSelected ? '✓' : '+';
        updateBuilderSummary();
      };

      const selectionObserver = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.attributeName === 'aria-pressed')) {
          scheduleUpdate();
        }
      });

      selectionObserver.observe(finder, {
        attributeFilter: ['aria-pressed'],
        attributes: true,
        subtree: true
      });

      const onAdd = async () => {
        if (!currentOffer) return;

        const activeOffer = currentOffer;
        const originalLabel = buttonElement.textContent;
        const quantities = new Map();

        activeOffer.items.forEach((item) => {
          quantities.set(item.id, (quantities.get(item.id) || 0) + 1);
        });

        buttonElement.disabled = true;
        buttonElement.textContent = config.dataset.addingLabel;
        messageElement.textContent = '';

        try {
          const response = await fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: Array.from(quantities, ([id, quantity]) => ({ id, quantity }))
            })
          });

          if (!response.ok) throw new Error('Cart request failed');

          document.dispatchEvent(new CustomEvent('cabincraft:finder-cart-added', {
            detail: {
              goal: activeOffer.goal,
              mode: activeOffer.mode,
              itemCount: activeOffer.items.length
            }
          }));

          window.location.assign(`${routeRoot}cart`);
        } catch (error) {
          buttonElement.disabled = false;
          buttonElement.textContent = originalLabel;
          messageElement.textContent = config.dataset.errorLabel;
        }
      };

      const onBuilderAdd = async () => {
        const items = getSelectedBuilderItems();
        if (items.length < 2) return;
        const originalLabel = builderAdd.textContent;
        const quantities = new Map();
        const customKitId = `cc-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
        const customKitProperties = {
          _cc_custom_kit: 'true',
          _cc_custom_kit_id: customKitId,
          _cc_custom_kit_discount: builderDiscountCopy
        };
        items.forEach((item) => quantities.set(item.id, (quantities.get(item.id) || 0) + 1));
        builderAdd.disabled = true;
        builderAdd.textContent = config.dataset.builderAdding;
        builderMessage.textContent = '';

        try {
          const response = await fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: Array.from(quantities, ([id, quantity]) => ({
                id,
                quantity,
                properties: customKitProperties
              }))
            })
          });

          if (!response.ok) throw new Error('Cart request failed');

          document.dispatchEvent(new CustomEvent('cabincraft:finder-cart-added', {
            detail: {
              goal: 'custom',
              mode: 'builder',
              itemCount: items.length,
              discountPercent: builderDiscountPercent,
              customKitId
            }
          }));
          const cartPath = `${routeRoot}cart`;
          const discountCode = (config.dataset.builderDiscountCode || '').trim();
          const destination = discountCode
            ? `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartPath)}`
            : cartPath;
          window.location.assign(destination);
        } catch (error) {
          builderAdd.disabled = false;
          builderAdd.textContent = originalLabel;
          builderMessage.textContent = config.dataset.errorLabel;
        }
      };

      finder.addEventListener('click', onFinderClick);
      buttonElement.addEventListener('click', onAdd);
      builderToggle.addEventListener('click', onBuilderToggle);
      builderClose.addEventListener('click', onBuilderClose);
      builderGrid.addEventListener('click', onBuilderSelect);
      builderAdd.addEventListener('click', onBuilderAdd);
      config.ccfcCleanup = () => {
        finder.removeEventListener('click', onFinderClick);
        buttonElement.removeEventListener('click', onAdd);
        builderToggle.removeEventListener('click', onBuilderToggle);
        builderClose.removeEventListener('click', onBuilderClose);
        builderGrid.removeEventListener('click', onBuilderSelect);
        builderAdd.removeEventListener('click', onBuilderAdd);
        selectionObserver.disconnect();
        if (updateFrame) window.cancelAnimationFrame(updateFrame);
        finder.removeAttribute('data-ccfc-goal');
        finder.style.removeProperty('--ccfc-accent');
        finder.style.removeProperty('--ccfc-accent-rgb');
        finder.style.removeProperty('--ccfc-accent-fill');
        builder.remove();
        builderPromo.remove();
        offer.remove();
      };

      updateBuilderSummary();
      update();
    };

    const initialiseAll = (scope = document) => {
      if (scope.matches && scope.matches(configSelector)) initialise(scope);
      scope.querySelectorAll(configSelector).forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(configSelector).forEach((config) => {
        if (config.ccfcCleanup) config.ccfcCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabincraft-promotion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-promo-banner')) {
    customElements.define('cc-promo-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const selector = this.querySelector('[data-promo-variant]');
        if (!selector) return;
        let variants;
        try { variants = JSON.parse(this.dataset.variants); } catch { return; }
        const money = value => {
          try { return new Intl.NumberFormat(this.dataset.locale || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD', currencyDisplay: 'narrowSymbol' }).format(value / 100); }
          catch { return (value / 100).toFixed(2); }
        };
        selector.addEventListener('change', () => {
          const variant = variants.find(item => String(item.id) === selector.value);
          if (!variant) return;
          const onSale = Number(variant.compare_at_price) > Number(variant.price);
          this.querySelector('[data-promo-price]').textContent = money(variant.price);
          this.querySelector('[data-promo-buy-price]').textContent = money(variant.price);
          this.querySelector('[data-promo-comparison]').hidden = !onSale;
          this.querySelector('[data-promo-was]').textContent = money(variant.compare_at_price || 0);
          this.querySelector('[data-promo-saving]').textContent = this.dataset.saveLabel + ' ' + money((variant.compare_at_price || 0) - variant.price);
          this.querySelector('[data-promo-badge]').textContent = onSale ? this.dataset.saleLabel : this.dataset.currentLabel;
          const buyButton = this.querySelector('[data-promo-buy]');
          buyButton.disabled = !variant.available;
          this.querySelector('[data-promo-buy-label]').textContent = variant.available ? this.dataset.buyLabel : this.dataset.soldOutLabel;
          this.querySelector('[data-promo-buy-price-wrap]').hidden = !variant.available;
          const details = this.querySelector('[data-promo-details]');
          const url = new URL(details.href);
          url.searchParams.set('variant', variant.id);
          details.href = url.toString();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
